export default __webpack_public_path__ + "static/media/oli.ee9e5b30.jpg";